__turbopack_context__.v({
  "button": "JoinDiscordButton-module__bDtrwG__button",
  "icon": "JoinDiscordButton-module__bDtrwG__icon",
});
